import BaseService from "../CorBase/BaseService";
import BaseFilter from '../CorBase/BaseFilter';

export class TenantpaidService extends BaseService {
	constructor() {
		super('/Tenantpaid');
	}


	public selectPaymentTenant(id: number, item: any) {
		return super.updateBase(`${this._resourceName}/select-paytenantservice/${id}`, item);
	}

	public getRemainingDiskSpace(idTenant: number) {
		return super.getByIdWithResourceName(idTenant, `${this._resourceName}/disk-remaining`);
	}

	public getAllByFilter(filter: TenantpaidFilter) {
		return super.getAllByFilterBase(filter);
	}
}

export class TenantpaidFilter extends BaseFilter {
	constructor(idTenant?: number | null) {
		super();

		this._idTenant = idTenant;
	}

	private _idTenant?: number | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._idTenant != null ? { IdTenant: this._idTenant } : {})

		);

		return data;
	};
}